/* eslint-disable no-console -- Allow */

// NOTE: A tracking system such as Sentry should replace the console

export const LogLevel = { NONE: 'NONE', ERROR: 'ERROR', WARN: 'WARN', DEBUG: 'DEBUG', ALL: 'ALL' };

const LogLevelNumber = { NONE: 0, ERROR: 1, WARN: 2, DEBUG: 3, ALL: 4 };

export class Logger {
  prefix;
  level;
  showLevel;

  levelNumber;

  constructor({ prefix = '', level = LogLevel.ALL, showLevel = true }) {
    this.prefix = prefix;
    this.level = level;
    this.levelNumber = LogLevelNumber[this.level];
    this.showLevel = showLevel;
  }

  debug = (...args) => {
    if (this.canWrite(LogLevel.DEBUG)) {
      this.write(LogLevel.DEBUG, ...args);
    }
  };

  warn = (...args) => {
    if (this.canWrite(LogLevel.WARN)) {
      this.write(LogLevel.WARN, ...args);
    }
  };

  error = (...args) => {
    if (this.canWrite(LogLevel.ERROR)) {
      this.write(LogLevel.ERROR, ...args);
    }
  };

  canWrite(level) {
    return this.levelNumber >= LogLevelNumber[level];
  }

  getCallLocation() {
    const error = new Error();
    const stack = error.stack;

    // The first line of the stack trace is typically the Error message itself.
    // The second line usually contains the information about where getCallLocation was called.
    const stackLines = stack.split('\n');

    if (stackLines.length > 2) {
      const callLine = stackLines[3]; // based on our call stack, the component is at this index
      const match = callLine.match(/\/src.*/); // extract file path and line number

      if (match && match.length >= 1) return match[0];
    }
    return null;
  }

  write(level, ...args) {
    // process.env.NODE_ENV is provided by node and tells us which mode the app is running in
    // production -> app is built for deployment (`npm run build`) and started via `npm start`
    // development -> app started via `npm run dev`
    if (process.env.NODE_ENV === "production") {
      return; // don't print to console in production
    }
    let prefix = this.prefix;

    if (this.showLevel) {
      prefix = `${level} ${prefix}`;
    }

    
    const location = this.getCallLocation();

    // if (level === LogLevel.ERROR) {
    //   console.error(`[${prefix}]`, ...args);
    // } else {
    //   console.log(`[${prefix}]`, ...args);
    // }

    if (location) {
      if (level === LogLevel.ERROR) {
        console.error(`[${prefix}]`, ...args, `${location}`);
      } else {
        console.log(`[${prefix}]`, ...args, `${location}`);
      }
    } else {
      if (level === LogLevel.ERROR) {
        console.error(`[${prefix}]`, ...args);
      } else {
        console.log(`[${prefix}]`, ...args);
      }
    }
  }
}

// This can be extended to create context specific logger (Server Action, Router Handler, etc.)
// to add context information (IP, User-Agent, timestamp, etc.)

export function createLogger({ prefix, level } = {}) {
  return new Logger({ prefix, level });
}
